import { axiosAction } from "../../utils/axiosAction";
import { 
  ATTRIBUTE_POST,
  ATTRIBUTE_FETCH,
  ATTRIBUTE_UPDATE,
  CLEAR_FOCUSED_ATTRIBUTE,
  SET_FOCUSED_ATTRIBUTE_MODE,
} from "../action-types/focused-attribute-types";
import { Modes } from '../reducers/focusedAttributeReducer';

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_ATTRIBUTES}`;


export const createAttribute = attribute => async dispatch => {
    return axiosAction.post(
        ENDPOINT,
        ATTRIBUTE_POST,
        dispatch,
        attribute,
    );
};

export const updateAttribute = attribute => async dispatch => {
  return axiosAction.put(
      `${ENDPOINT}/${attribute.id}`,
      ATTRIBUTE_UPDATE,
      dispatch,
      attribute,
  );
};

export const editAttribute = (id: number) => dispatch => {
  dispatch({ type: SET_FOCUSED_ATTRIBUTE_MODE, payload: Modes.EDIT });
  return getSingleAttribute(id)(dispatch);
};

export const viewAttribute = (id: number) => dispatch => {
  dispatch({ type: SET_FOCUSED_ATTRIBUTE_MODE, payload: Modes.VIEW });
  return getSingleAttribute(id)(dispatch);
};

export const newAttribute = () => dispatch => {
  dispatch({ type: SET_FOCUSED_ATTRIBUTE_MODE, payload: Modes.NEW });
};

export const getSingleAttribute = (id: number) => async dispatch => {
    return axiosAction.get(
        `${ENDPOINT}/${id}`,
        ATTRIBUTE_FETCH,
        dispatch,
    );
};

export const clearFocusedAttribute = () => ({ type: CLEAR_FOCUSED_ATTRIBUTE });
